/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Document } from '../../../core/models/Document';
import { AuthorizationCodeOAuthFlow } from '../../../core/models/common/AuthorizationCodeOAuthFlow';
import { ClientCredentialsOAuthFlow } from '../../../core/models/common/ClientCredentialsOAuthFlow';
import { Components } from '../../../core/models/common/Components';
import { IExample } from '../../../core/models/common/IExample';
import { ImplicitOAuthFlow } from '../../../core/models/common/ImplicitOAuthFlow';
import { ModernSecurityScheme } from '../../../core/models/common/ModernSecurityScheme';
import { OAuthFlows } from '../../../core/models/common/OAuthFlows';
import { Operation } from '../../../core/models/common/Operation';
import { Parameter } from '../../../core/models/common/Parameter';
import { PasswordOAuthFlow } from '../../../core/models/common/PasswordOAuthFlow';
import { Schema } from '../../../core/models/common/Schema';
import { SecurityScheme } from '../../../core/models/common/SecurityScheme';
import { Server } from '../../../core/models/common/Server';
import { ServerVariable } from '../../../core/models/common/ServerVariable';
import { OasHeader } from '../../models/OasHeader';
import { OasPathItem } from '../../models/OasPathItem';
import { OasResponse } from '../../models/OasResponse';
import { Oas30Callback } from '../models/Oas30Callback';
import { Oas30CallbackDefinition } from '../models/Oas30CallbackDefinition';
import { Oas30CallbackPathItem } from '../models/Oas30CallbackPathItem';
import { Oas30Components } from '../models/Oas30Components';
import { Oas30Discriminator } from '../models/Oas30Discriminator';
import { Oas30Document } from '../models/Oas30Document';
import { Oas30Encoding } from '../models/Oas30Encoding';
import { Oas30Example } from '../models/Oas30Example';
import { Oas30ExampleDefinition } from '../models/Oas30ExampleDefinition';
import { Oas30Header } from '../models/Oas30Header';
import { Oas30HeaderDefinition } from '../models/Oas30HeaderDefinition';
import { Oas30Link } from '../models/Oas30Link';
import { Oas30LinkDefinition } from '../models/Oas30LinkDefinition';
import { Oas30LinkParameterExpression } from '../models/Oas30LinkParameterExpression';
import { Oas30LinkRequestBodyExpression } from '../models/Oas30LinkRequestBodyExpression';
import { Oas30LinkServer } from '../models/Oas30LinkServer';
import { Oas30MediaType } from '../models/Oas30MediaType';
import { Oas30Operation } from '../models/Oas30Operation';
import { Oas30Parameter } from '../models/Oas30Parameter';
import { Oas30PathItem } from '../models/Oas30PathItem';
import { Oas30RequestBody } from '../models/Oas30RequestBody';
import { Oas30RequestBodyDefinition } from '../models/Oas30RequestBodyDefinition';
import { Oas30Response } from '../models/Oas30Response';
import { Oas30Schema } from '../models/Oas30Schema';
import { OasTraverser } from '../../visitors/OasTraverser';
import { IOas30Visitor } from './IOas30Visitor';
import { OasSchema } from '../../models/OasSchema';
import { IVisitor } from '../../../core/visitors/IVisitor';

/**
 * Constructor.
 * @param {*} visitor
 * @class
 * @extends OasTraverser
 * @author eric.wittmann@gmail.com
 */
export class Oas30Traverser extends OasTraverser implements IOas30Visitor {
    public constructor(visitor : IOas30Visitor) {
        super(visitor);
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.OasTraverser#traverseDocument(io.apicurio.datamodels.core.models.Document)
     * @param {Document} node
     */
    traverseDocument(node : Document) {
        let doc : Oas30Document = <Oas30Document>node;
        super.traverseDocument(doc);
        this.traverseCollection(doc.servers);
        this.traverseIfNotNull(doc.components);
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.Traverser#traverseParameter(io.apicurio.datamodels.core.models.common.Parameter)
     * @param {Parameter} node
     */
    traverseParameter(node : Parameter) {
        super.traverseParameter(node);
        let param : Oas30Parameter = <Oas30Parameter>node;
        this.traverseCollection(param.getExamples());
        this.traverseCollection(param.getMediaTypes());
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.OasTraverser#traverseResponse(io.apicurio.datamodels.openapi.models.OasResponse)
     * @param {OasResponse} node
     */
    traverseResponse(node : OasResponse) {
        super.traverseResponse(node);
        let response : Oas30Response = <Oas30Response>node;
        this.traverseCollection(response.getHeaders());
        this.traverseCollection(response.getMediaTypes());
        this.traverseCollection(response.getLinks());
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.OasTraverser#traverseSchema(io.apicurio.datamodels.core.models.common.Schema)
     * @param {Schema} node
     */
    traverseSchema(node : Schema) {
        super.traverseSchema(node);
        let schema : Oas30Schema = <Oas30Schema>node;
        this.traverseCollection(schema.oneOf);
        this.traverseCollection(schema.anyOf);
        this.traverseIfNotNull(schema.not);
        this.traverseIfNotNull(schema.discriminator);
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.OasTraverser#traverseOperation(io.apicurio.datamodels.core.models.common.Operation)
     * @param {Operation} node
     */
    traverseOperation(node : Operation) {
        super.traverseOperation(node);
        let op : Oas30Operation = <Oas30Operation>node;
        this.traverseIfNotNull(op.requestBody);
        this.traverseCollection(op.getCallbacks());
        this.traverseCollection(op.servers);
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.OasTraverser#traverseHeader(io.apicurio.datamodels.openapi.models.OasHeader)
     * @param {OasHeader} node
     */
    traverseHeader(node : OasHeader) {
        super.traverseHeader(node);
        let header : Oas30Header = <Oas30Header>node;
        this.traverseIfNotNull(header.schema);
        this.traverseCollection(header.getExamples());
        this.traverseCollection(header.getMediaTypes());
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitComponents(io.apicurio.datamodels.core.models.common.Components)
     * @param {Components} node
     */
    public visitComponents(node : Components) {
        let components : Oas30Components = <Oas30Components>node;
        node.accept(this.visitor);
        this.traverseCollection(components.getSchemaDefinitions());
        this.traverseCollection(components.getResponseDefinitions());
        this.traverseCollection(components.getParameterDefinitions());
        this.traverseCollection(components.getExampleDefinitions());
        this.traverseCollection(components.getRequestBodyDefinitions());
        this.traverseCollection(components.getHeaderDefinitions());
        this.traverseCollection(components.getSecuritySchemes());
        this.traverseCollection(components.getLinkDefinitions());
        this.traverseCollection(components.getCallbackDefinitions());
        this.traverseExtensions(node);
        this.traverseValidationProblems(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.OasTraverser#traversePathItem(io.apicurio.datamodels.openapi.models.OasPathItem)
     * @param {OasPathItem} node
     */
    traversePathItem(node : OasPathItem) {
        super.traversePathItem(node);
        let pathItem : Oas30PathItem = <Oas30PathItem>node;
        this.traverseIfNotNull(pathItem.trace);
        this.traverseCollection(pathItem.servers);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitCallbackPathItem(io.apicurio.datamodels.openapi.v3.models.Oas30CallbackPathItem)
     * @param {Oas30CallbackPathItem} node
     */
    public visitCallbackPathItem(node : Oas30CallbackPathItem) {
        this.visitPathItem(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitCallback(io.apicurio.datamodels.openapi.v3.models.Oas30Callback)
     * @param {Oas30Callback} node
     */
    public visitCallback(node : Oas30Callback) {
        node.accept(this.visitor);
        this.traverseIndexedNode(node);
        this.traverseExtensions(node);
        this.traverseValidationProblems(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitLinkServer(io.apicurio.datamodels.openapi.v3.models.Oas30LinkServer)
     * @param {Oas30LinkServer} node
     */
    public visitLinkServer(node : Oas30LinkServer) {
        this.visitServer(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitCallbackDefinition(io.apicurio.datamodels.openapi.v3.models.Oas30CallbackDefinition)
     * @param {Oas30CallbackDefinition} node
     */
    public visitCallbackDefinition(node : Oas30CallbackDefinition) {
        this.visitCallback(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitLink(io.apicurio.datamodels.openapi.v3.models.Oas30Link)
     * @param {Oas30Link} node
     */
    public visitLink(node : Oas30Link) {
        node.accept(this.visitor);
        this.traverseCollection(node.getLinkParameterExpressions());
        this.traverseIfNotNull(node.requestBody);
        this.traverseIfNotNull(node.server);
        this.traverseExtensions(node);
        this.traverseValidationProblems(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitLinkRequestBodyExpression(io.apicurio.datamodels.openapi.v3.models.Oas30LinkRequestBodyExpression)
     * @param {Oas30LinkRequestBodyExpression} node
     */
    public visitLinkRequestBodyExpression(node : Oas30LinkRequestBodyExpression) {
        node.accept(this.visitor);
        this.traverseValidationProblems(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitLinkParameterExpression(io.apicurio.datamodels.openapi.v3.models.Oas30LinkParameterExpression)
     * @param {Oas30LinkParameterExpression} node
     */
    public visitLinkParameterExpression(node : Oas30LinkParameterExpression) {
        node.accept(this.visitor);
        this.traverseValidationProblems(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitLinkDefinition(io.apicurio.datamodels.openapi.v3.models.Oas30LinkDefinition)
     * @param {Oas30LinkDefinition} node
     */
    public visitLinkDefinition(node : Oas30LinkDefinition) {
        this.visitLink(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitAuthorizationCodeOAuthFlow(io.apicurio.datamodels.core.models.common.AuthorizationCodeOAuthFlow)
     * @param {AuthorizationCodeOAuthFlow} node
     */
    public visitAuthorizationCodeOAuthFlow(node : AuthorizationCodeOAuthFlow) {
        this.traverseOAuthFlow(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitClientCredentialsOAuthFlow(io.apicurio.datamodels.core.models.common.ClientCredentialsOAuthFlow)
     * @param {ClientCredentialsOAuthFlow} node
     */
    public visitClientCredentialsOAuthFlow(node : ClientCredentialsOAuthFlow) {
        this.traverseOAuthFlow(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitPasswordOAuthFlow(io.apicurio.datamodels.core.models.common.PasswordOAuthFlow)
     * @param {PasswordOAuthFlow} node
     */
    public visitPasswordOAuthFlow(node : PasswordOAuthFlow) {
        this.traverseOAuthFlow(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitImplicitOAuthFlow(io.apicurio.datamodels.core.models.common.ImplicitOAuthFlow)
     * @param {ImplicitOAuthFlow} node
     */
    public visitImplicitOAuthFlow(node : ImplicitOAuthFlow) {
        this.traverseOAuthFlow(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitOAuthFlows(io.apicurio.datamodels.core.models.common.OAuthFlows)
     * @param {OAuthFlows} node
     */
    public visitOAuthFlows(node : OAuthFlows) {
        this.traverseOAuthFlows(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.IOasVisitor#visitExample(io.apicurio.datamodels.core.models.common.IExample)
     * @param {*} node
     */
    public visitExample(node : IExample) {
        let example30 : Oas30Example = <Oas30Example><any>node;
        node.accept(this.visitor);
        this.traverseExtensions(example30);
        this.traverseValidationProblems(example30);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitEncoding(io.apicurio.datamodels.openapi.v3.models.Oas30Encoding)
     * @param {Oas30Encoding} node
     */
    public visitEncoding(node : Oas30Encoding) {
        node.accept(this.visitor);
        this.traverseCollection(node.getHeaders());
        this.traverseExtensions(node);
        this.traverseValidationProblems(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitMediaType(io.apicurio.datamodels.openapi.v3.models.Oas30MediaType)
     * @param {Oas30MediaType} node
     */
    public visitMediaType(node : Oas30MediaType) {
        node.accept(this.visitor);
        this.traverseIfNotNull(node.schema);
        this.traverseCollection(node.getExamples());
        this.traverseCollection(node.getEncodings());
        this.traverseExtensions(node);
        this.traverseValidationProblems(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitHeaderDefinition(io.apicurio.datamodels.openapi.v3.models.Oas30HeaderDefinition)
     * @param {Oas30HeaderDefinition} node
     */
    public visitHeaderDefinition(node : Oas30HeaderDefinition) {
        this.visitHeader(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitRequestBody(io.apicurio.datamodels.openapi.v3.models.Oas30RequestBody)
     * @param {Oas30RequestBody} node
     */
    public visitRequestBody(node : Oas30RequestBody) {
        node.accept(this.visitor);
        this.traverseCollection(node.getMediaTypes());
        this.traverseExtensions(node);
        this.traverseValidationProblems(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitRequestBodyDefinition(io.apicurio.datamodels.openapi.v3.models.Oas30RequestBodyDefinition)
     * @param {Oas30RequestBodyDefinition} node
     */
    public visitRequestBodyDefinition(node : Oas30RequestBodyDefinition) {
        this.visitRequestBody(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitExampleDefinition(io.apicurio.datamodels.openapi.v3.models.Oas30ExampleDefinition)
     * @param {Oas30ExampleDefinition} node
     */
    public visitExampleDefinition(node : Oas30ExampleDefinition) {
        this.visitExample(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitDiscriminator(io.apicurio.datamodels.openapi.v3.models.Oas30Discriminator)
     * @param {Oas30Discriminator} node
     */
    public visitDiscriminator(node : Oas30Discriminator) {
        node.accept(this.visitor);
        this.traverseValidationProblems(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitNotSchema(io.apicurio.datamodels.openapi.v3.models.Oas30Schema.Oas30NotSchema)
     * @param {Oas30Schema.Oas30NotSchema} node
     */
    public visitNotSchema(node : Oas30Schema.Oas30NotSchema) {
        this.visitSchema(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitOneOfSchema(io.apicurio.datamodels.openapi.v3.models.Oas30Schema.Oas30OneOfSchema)
     * @param {Oas30Schema.Oas30OneOfSchema} node
     */
    public visitOneOfSchema(node : Oas30Schema.Oas30OneOfSchema) {
        this.visitSchema(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitAnyOfSchema(io.apicurio.datamodels.openapi.v3.models.Oas30Schema.Oas30AnyOfSchema)
     * @param {Oas30Schema.Oas30AnyOfSchema} node
     */
    public visitAnyOfSchema(node : Oas30Schema.Oas30AnyOfSchema) {
        this.visitSchema(node);
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.Traverser#traverseSecurityScheme(io.apicurio.datamodels.core.models.common.SecurityScheme)
     * @param {SecurityScheme} node
     */
    traverseSecurityScheme(node : SecurityScheme) {
        super.traverseSecurityScheme(node);
        let scheme : ModernSecurityScheme = <ModernSecurityScheme>node;
        this.traverseIfNotNull(scheme.flows);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitServer(io.apicurio.datamodels.core.models.common.Server)
     * @param {Server} node
     */
    public visitServer(node : Server) {
        node.accept(this.visitor);
        this.traverseCollection(node.getServerVariables());
        this.traverseExtensions(node);
        this.traverseValidationProblems(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitServerVariable(io.apicurio.datamodels.core.models.common.ServerVariable)
     * @param {ServerVariable} node
     */
    public visitServerVariable(node : ServerVariable) {
        node.accept(this.visitor);
        this.traverseExtensions(node);
        this.traverseValidationProblems(node);
    }
}
Oas30Traverser["__class"] = "io.apicurio.datamodels.openapi.v3.visitors.Oas30Traverser";
Oas30Traverser["__interfaces"] = ["io.apicurio.datamodels.core.visitors.IVisitor","io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor","io.apicurio.datamodels.core.visitors.ITraverser","io.apicurio.datamodels.openapi.visitors.IOasVisitor"];




